const RateList = () => import(/* webpackChunkName: "PlayerList" */ './containers/RateGrid.vue');

export const ratesRouting = [
    {path: '/rates', name: 'rates-list', component: RateList},
]
